import React from "react";
import { parsal_img } from "../../../assets/mediaCall";

const Services = () => {
  const features = [
    {
      title: "Real-Time Tracking",
      description: "Never Lose Sight of Your Shipments",
      detail:
        "Track every delivery in real-time with instant updates and detailed maps, ensuring complete visibility from pickup to drop-off.",
    },
    {
      title: "Route Optimization",
      description: "Save Time and Fuel",
      detail:
        "Our smart algorithms help drivers find the fastest, most efficient routes, reducing fuel costs and improving delivery times.",
    },
    {
      title: "Driver Management",
      description: "Effortlessly Manage Your Fleet",
      detail:
        "Assign tasks, monitor performance, and stay connected with your drivers in just a few taps. Easy fleet management, anytime, anywhere.",
    },
  ];

  return (
    <div className="bg-[#FCFCFF] inter flex">
      <div className="w-1/2 mlg:w-[90vw] smp:w-[93vw] mx-auto flex items-center justify-between gap-2 px-0 py-20 mdg:py-10">
        {/* Text and Features Section */}
        <div className="w-[85%] ml-auto mlg:w-full mlg:ml-0">
          <h3 className="text-[#6D6D6D] sm:text-[14px] font-semibold mb-2">
            OUR SERVICES
          </h3>
          <h1 className="text-[#000000] font-bold text-[30px] sm:text-2xl leading-[36px]">
            Packed with Features to Simplify Your Logistics
          </h1>

          <div>
            {features.map((feature, index) => (
              <div
                key={index}
                style={{ boxShadow: "0px 4px 24px 0px #0000000A" }}
                className="bg-white shadow-sm px-7 py-5 smp:px-5 smp:py-4 rounded-[20px] flex my-6"
              >
                <div className="p-2 border-l-4 border-[#3D40D1]"></div>
                <div>
                  <h4 className="font-semibold text-[20px] text-[#3D40D1]">
                    {feature.title}
                  </h4>
                  <p className="text-[#000000] font-semibold text-[16px]">
                    {feature.description}
                  </p>
                  <p className="text-[14px] font-normal text-[#777777]">
                    {feature.detail}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Image and Floating Labels Section */}
      <div className="w-1/2 flex justify-center relative mlg:hidden">
        <img
          src={parsal_img.woman}
          alt="Service Features"
          className="max-h-[774px] object-contain"
        />

        {/* Floating Labels */}
        <div className="absolute top-[60%] xxl:top-[52%] left-[30%] transform -translate-x-1/2 bg-white p-3 rounded-lg shadow-md flex gap-2 items-center">
          <div className="w-10 h-10">
            <img src={parsal_img.ship2} className="h-full w-full" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900">
              Shipment Tracking
            </p>
            <p className="text-xs text-gray-500">
              Track your shipment Anywhere
            </p>
          </div>
        </div>
        <div className="absolute bottom-[12%] xxl:bottom-[25%] lg:bottom-[27%] right-[20%] bg-white p-3 rounded-lg shadow-md flex gap-2 items-center">
          {/* <div className="w-4 h-4">
              <img
                src={parsal_img.frame1}
                alt="image.png"
                className="h-full w-full object-contain"
              />
            </div> */}
          <div className="w-10 h-10">
            <img src={parsal_img.ship1} className="h-full w-full" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900">
              Insurance Coverage
            </p>
            <p className="text-xs text-gray-500">
              Don’t need to worry about your package
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
